import * as Vue from 'vue';
import VueRouter from 'vue-router';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import VueToast from 'vue-toast-notification';
import VueTheMask from 'vue-the-mask';
import VueCurrencyFilter from 'vue-currency-filter';
import VueCurrencyInput from 'vue-currency-input';
import VueSuperagent from 'vue-superagent';
import vSelect from 'vue-select';
import Multiselect from 'vue-multiselect';
import { routes } from './routes';
import './app.scss';

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(VueToast);
Vue.use(VueTheMask);
Vue.use(VueSuperagent);
Vue.component('multiselect', Multiselect);

Vue.use(VueCurrencyInput, {
  globalOptions: { currency: 'BRL', autoDecimalMode: true },
});

Vue.use(VueCurrencyFilter, {
  symbol: 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true,
});

Vue.component(
  'currency-input',
  require('../components/currency-input.vue').default,
);

Vue.component(
  'submit-button',
  require('../components/submit-button.vue').default,
);

Vue.component(
  'error-container',
  require('../components/error-container.vue').default,
);

Vue.component(
  'loading-list',
  require('../components/loading-list.vue').default,
);

Vue.component('v-table', require('../components/table.vue').default);

Vue.component('empty-list', require('../components/empty-list.vue').default);

Vue.component('v-select', vSelect);

const router = new VueRouter({
  routes: routes,
});

const DEFAULT_TITLE = 'Portal Administrator';
router.afterEach((to, from) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

const app = new Vue({
  router,
}).$mount('#app');
